import { ref, computed } from '@vue/composition-api'
import store from '@/store'
import { apiToastError, apiToastSuccess, apiToastWarning } from '@/@core/utils/toast'
import constants from '@/constants'
import {
  GET_CONNECTION_INFO,
  SEND_CENNECTION_REQUEST,
  UPDATE_CONNECTION_REQUEST,
} from '@/store/modules/connections.module'

const { CONNECTION_REQUEST_STATUS } = constants

export { CONNECTION_REQUEST_STATUS }

export function useConnectionRequest() {
  const retailerData = ref(null)
  const brandData = ref(null)
  const message = ref('')
  const loaded = ref(false)

  const isBrand = computed(() => store.getters.isBrand)
  const isRetailer = computed(() => store.getters.isRetailer)

  function isButtonEnabled(status) {
    return status === CONNECTION_REQUEST_STATUS.PENDING
  }

  function isUpdateEnabledRetailer(status) {
    return isRetailer.value && (!status || status === CONNECTION_REQUEST_STATUS.PENDING)
  }

  function websiteLink(link) {
    if (!link) return ''
    if (link.includes('https://') || link.includes('http://')) {
      return link
    }
    return `http://${link}`
  }

  async function fetchConnectionInfo({ brandId, retailerId }) {
    loaded.value = false
    const params = {}
    if (isRetailer.value) {
      params.brandId = brandId
    } else {
      params.retailerId = retailerId
    }
    try {
      const res = await store.dispatch(GET_CONNECTION_INFO, params)
      retailerData.value = res.data.data.retailerInfo
      brandData.value = res.data.data.brandInfo
      message.value = res.data.data.message || ''
      loaded.value = true
    } catch (err) {
      apiToastError(err)
    }
  }

  async function submitNewRequest(brandId) {
    try {
      const payload = {
        brandId,
        message: message.value,
      }
      await store.dispatch(SEND_CENNECTION_REQUEST, payload)
      apiToastSuccess('Connection Request made')
      return { success: true }
    } catch {
      return { success: false }
    }
  }

  async function updateExistingRequest(requestId, newStatus, originalMessage) {
    if (isRetailer.value && message.value === originalMessage) {
      apiToastWarning('No changes found')
      return { success: false, noChanges: true }
    }
    const toastMessage = isBrand.value ? `Request ${newStatus}` : 'Request message updated'
    try {
      const payload = { status: newStatus, message: message.value }
      await store.dispatch(UPDATE_CONNECTION_REQUEST, { requestId, payload })
      apiToastSuccess(toastMessage)
      return { success: true }
    } catch {
      return { success: false }
    }
  }

  return {
    retailerData,
    brandData,
    message,
    loaded,
    isBrand,
    isRetailer,
    isButtonEnabled,
    isUpdateEnabledRetailer,
    websiteLink,
    fetchConnectionInfo,
    submitNewRequest,
    updateExistingRequest,
    CONNECTION_REQUEST_STATUS,
  }
}
